import React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Visible = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6.54351C6.00849 6.54351 3.60448 8.92823 2.63593 10.1484C2.51244 10.3035 2.51244 10.5011 2.63593 10.6562C3.60448 11.8763 6.00849 14.2611 10 14.2611C13.9915 14.2611 16.3963 11.8763 17.3641 10.6562C17.4876 10.5011 17.4876 10.3035 17.3641 10.1484C16.3963 8.92823 13.9915 6.54351 10 6.54351ZM1.42659 9.18908C2.53097 7.79838 5.33166 5 10 5C14.6683 5 17.4698 7.79838 18.5734 9.18908C19.1422 9.90604 19.1422 10.8985 18.5734 11.6155C17.4698 13.0062 14.6683 15.8046 10 15.8046C5.33166 15.8046 2.53097 13.0062 1.42659 11.6155C0.857804 10.8985 0.857804 9.90604 1.42659 9.18908ZM10 8.85877C9.14798 8.85877 8.45649 9.55026 8.45649 10.4023C8.45649 11.2543 9.14798 11.9458 10 11.9458C10.852 11.9458 11.5435 11.2543 11.5435 10.4023C11.5435 9.55026 10.852 8.85877 10 8.85877ZM6.91298 10.4023C6.91298 8.69747 8.2952 7.31526 10 7.31526C11.7048 7.31526 13.087 8.69747 13.087 10.4023C13.087 12.1071 11.7048 13.4893 10 13.4893C8.2952 13.4893 6.91298 12.1071 6.91298 10.4023Z"
      fill="var(--color-neutral-slate, #58626E)"
    />
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Invisible = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6.54351C6.00849 6.54351 3.60448 8.92823 2.63593 10.1484C2.51244 10.3035 2.51244 10.5011 2.63593 10.6562C3.60448 11.8763 6.00849 14.261 10 14.261C13.9915 14.261 16.3963 11.8763 17.3641 10.6562C17.4876 10.5011 17.4876 10.3035 17.3641 10.1484C16.3963 8.92823 13.9915 6.54351 10 6.54351ZM1.42659 9.18908C2.53097 7.79838 5.33166 5 10 5C14.6683 5 17.4698 7.79838 18.5734 9.18908C19.1422 9.90604 19.1422 10.8985 18.5734 11.6155C17.4698 13.0062 14.6683 15.8046 10 15.8046C5.33166 15.8046 2.53097 13.0062 1.42659 11.6155C0.857804 10.8985 0.857804 9.90604 1.42659 9.18908ZM10 8.85877C9.14798 8.85877 8.45649 9.55026 8.45649 10.4023C8.45649 11.2543 9.14798 11.9458 10 11.9458C10.852 11.9458 11.5435 11.2543 11.5435 10.4023C11.5435 9.55026 10.852 8.85877 10 8.85877ZM6.91298 10.4023C6.91298 8.69747 8.2952 7.31526 10 7.31526C11.7048 7.31526 13.087 8.69747 13.087 10.4023C13.087 12.1071 11.7048 13.4893 10 13.4893C8.2952 13.4893 6.91298 12.1071 6.91298 10.4023Z"
      fill="#58626E"
    />
    <path
      d="M2 2L18 18"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M2 4L16 18"
      stroke="#58626E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
